import React, { useState } from 'react';
import {
  Container,
  Button,
  Nav,
  NavItem,
  NavLink,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';
import RegistroCuentaPaso1 from './RegistroCuentaPaso1';
import RegistroCuentaPaso2 from './RegistroCuentaPaso2';
import RegistroCuentaPaso3VerifCodMail from './RegistroCuentaPaso3VerifCodMail';
import RegistroCuentaPaso4SMS from './RegistroCuentaPaso4SMS';
import RegistroCuentaPaso5Activacion from './RegistroCuentaPaso5Activacion';
import { useTranslation } from 'react-i18next';

// Tabla de pasos (solo IDs + key de traducción)
const steps = [
  { id: 1, key: 'basicInfo' },
  { id: 2, key: 'personalData' },
  { id: 3, key: 'verifyEmail' },
  { id: 4, key: 'verifySMS' },
  { id: 5, key: 'activation' },
];

const RegistroCuentaWizard = ({ onComplete }) => {
  const [step, setStep] = useState(1);
  const [registrationId, setRegistrationId] = useState(null);
  const [activationMailId, setActivationMailId] = useState(null);
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();

  // i18n – namespace "activation"
  const { t } = useTranslation('activation');

  const handleComplete = () => {
    setModal(true);
  };

  const handleRedirect = () => {
    setModal(false);
    // Redirigir al login (ajusta la ruta si tu login está en /auth/login)
    navigate('/login');
  };

  return (
    <Container className="py-5" style={{ maxWidth: 700 }}>
      {/* Breadcrumb de pasos */}
      <Nav pills className="justify-content-between mb-4">
        {steps.map((s) => (
          <NavItem key={s.id} className="text-center flex-fill">
            <NavLink
              className={classnames('d-block mx-auto', { active: s.id === step })}
              style={{
                cursor: 'default',
                borderRadius: '50%',
                width: '2.5rem',
                height: '2.5rem',
                lineHeight: '1.8rem',
                backgroundColor: s.id <= step ? '#bb1194' : '#e9ecef',
                color: s.id <= step ? '#fff' : '#6c757d',
                fontWeight: 'bold',
                marginBottom: '.5rem',
              }}
            >
              {s.id}
            </NavLink>
            {/* Etiqueta del paso traducida */}
            <div className="small">
              {t(`wizard.steps.${s.key}`)}
            </div>
          </NavItem>
        ))}
      </Nav>

      {/* Contenido de cada paso */}
      <div className="mb-4">
        {step === 1 && (
          <RegistroCuentaPaso1
            onNext={(id) => {
              setRegistrationId(id);
              setStep(2);
            }}
          />
        )}

        {step === 2 && registrationId && (
          <RegistroCuentaPaso2
            registrationId={registrationId}
            onNext={() => setStep(3)}
          />
        )}

        {step === 3 && registrationId && (
          <RegistroCuentaPaso3VerifCodMail
            registrationId={registrationId}
            onNext={(mailId) => {
              setActivationMailId(mailId);
              setStep(4);
            }}
          />
        )}

        {step === 4 && activationMailId && (
          <RegistroCuentaPaso4SMS
            registrationId={registrationId}
            onNext={() => setStep(5)}
          />
        )}

        {step === 5 && activationMailId && (
          <RegistroCuentaPaso5Activacion
            registrationId={registrationId}
            onFinish={(ok) => {
              if (ok) {
                // onComplete?.();
                handleComplete();
              }
            }}
          />
        )}
      </div>

      {/* Botones de navegación inferiores */}
      <Row>
        <Col className="text-start">
          {step > 1 && (
            <Button color="secondary" onClick={() => setStep((s) => s - 1)}>
              {t('common.previous')}
            </Button>
          )}
        </Col>
      </Row>

      {/* Modal final de registro exitoso (por si decides usarlo además del del paso 5) */}
      <Modal isOpen={modal} toggle={() => setModal(!modal)}>
        <ModalHeader toggle={() => setModal(!modal)}>
          {t('wizard.finalModal.title')}
        </ModalHeader>
        <ModalBody>{t('wizard.finalModal.body')}</ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleRedirect}>
            {t('wizard.finalModal.accept')}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
};

export default RegistroCuentaWizard;
